module.exports = __webpack_public_path__ + "img/solution_5.6c7fa38c.png";